import React from 'react';
import Image from 'next/image';
import { trustedByContent } from '@anonymizePro/mock/contents';

function Index() {
    return (
        <div className="layoutMarginAndRound flex h-[429px] w-full flex-col items-center justify-center gap-12 bg-white py-10">
            <p className="anonymize-p1 text-black-800">{trustedByContent.title}</p>
            <div className="flex flex-row gap-10">
                {trustedByContent.clients.map((client) => (
                    <Image key={client.name} src={client.logo} height={79} width={101} alt="client logo" />
                ))}
            </div>
        </div>
    );
}

export default Index;
